import React from 'react';

const GenerationContext = React.createContext({});

export const GenerationProvider = GenerationContext.Provider;
export const GenerationConsumer = GenerationContext.Consumer;

export default GenerationContext;
